import {
    getDisplayValue,
    windCardinal
} from '../format-display-value';

/**
 * Hourly data should have the following structure:
 * {
 *      DF: "string",
 *      DateTime: "string",
 *      Direction: "string",
 *      FBI: "string",
 *      FDR: "string",
 *      Humidity: "string",
 *      Speed: "string",
 *      Temperature: "string"
 * }
 * @param {*} hourlyData 
 * @param {*} detailsContainer 
 */
export function drawWindSpeedChart(hourlyData, detailsContainer, chartHeight) {
    // Create the temperature data array
    const temp = [['Datetime', 'WindSpeed', { role: 'tooltip', 'p': {'html': true}}]];

    const dateFormatOptions = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true
    }

    const fontSize = `font-size:11px;`;

    hourlyData.forEach((item) => {
        const dateVal = new Date(item['DateTime']);
        const windSpeedVal = getDisplayValue(item['Speed'], 'WindSpeed');
        const windDirVal = windCardinal(+item['Direction']);

        let toolTip = '';

        toolTip += `<b>${dateVal.toLocaleString("en-US", dateFormatOptions)}</b><br/>`
        toolTip += `Wind Speed: <b>${windSpeedVal}</b> ${windDirVal}`

        toolTip = `<div style="padding:5px;${fontSize}">${toolTip}</div>`

        temp.push([
            dateVal, 
            getDisplayValue(item['Speed'], 'WindSpeed'), 
            toolTip
        ]);
    })

    const data = google.visualization.arrayToDataTable(temp);

    const options = {
        title: 'Wind Speed (km/h)',
        legend: 'none',
        chartArea: {width: '85%'},  // Adjust chart area
        tooltip: { isHtml: true },
        height: +chartHeight.slice(0, -2)
    };

    const chartContainer = $(
            `<div class="no-data ` + 
                    `line-chart-container ` +
                    `chart-container-style" ` + 
                `id="wind-speed-line-chart-id"` +
                `style="height:${chartHeight};"></div>`);
    detailsContainer.append(chartContainer);

    const chart = new google.visualization.LineChart(document.getElementById('wind-speed-line-chart-id'));
    chart.draw(data, options);
}